import Seo from "@/components/Seo";

export default function LegalLayout({ title, description, path, updated, children, jsonLd }) {
  return (
    <div className="container-mtr py-10 sm:py-14 max-w-3xl" data-testid="legal-page">
      <Seo title={`${title} — MeasureTheRoof`} description={description} path={path} jsonLd={jsonLd} />
      <span className="eyebrow">Legal</span>
      <h1 className="font-body font-extrabold text-navy text-[30px] sm:text-[38px] mt-2">{title}</h1>
      <p className="text-mortar text-[14px] mt-2">Last updated: {updated}</p>
      <div className="legal-body mt-8 space-y-6 text-[15px] text-iron leading-relaxed">{children}</div>
    </div>
  );
}

export function H2({ children, id }) {
  return <h2 id={id} className="font-body font-extrabold text-navy text-[22px] mt-8 mb-2">{children}</h2>;
}
export function H3({ children }) {
  return <h3 className="font-bold text-navy text-[17px] mt-4 mb-1">{children}</h3>;
}
export function P({ children }) {
  return <p className="leading-relaxed">{children}</p>;
}
export function UL({ children }) {
  return <ul className="list-disc pl-5 space-y-1.5 marker:text-orange">{children}</ul>;
}
